import type { NotificationPreferences } from '@/api/types';

export const DEFAULT_NOTIFICATION_PREFERENCES: NotificationPreferences = {
  enabled_types: {},
  web_enabled: true,
  push_enabled: true,
  telegram_enabled: false,
  quiet_hours_start: null,
  quiet_hours_end: null,
  max_per_type_per_day: 20,
};

/** True when the tenant has moved off vanilla defaults (used for settings summary cards). */
export function notificationPreferencesLookCustom(p: NotificationPreferences): boolean {
  const d = DEFAULT_NOTIFICATION_PREFERENCES;
  if (p.quiet_hours_start !== null || p.quiet_hours_end !== null) return true;
  if (p.max_per_type_per_day !== d.max_per_type_per_day) return true;
  if (p.web_enabled !== d.web_enabled || p.push_enabled !== d.push_enabled || p.telegram_enabled !== d.telegram_enabled) {
    return true;
  }
  if (Object.keys(p.enabled_types ?? {}).length > 0) return true;
  return false;
}
